export default "<div class=\"quotes\"></div>\n<div>\n  <ng-content></ng-content>\n</div>\n"